import { authEventType, dataDogStatus, httpMethods } from 'api/constants';
import { environment as env } from 'constants/environment';
import { type AuthenticateLogSchema } from 'api/types';
import { datadogRum } from '@datadog/browser-rum-slim';

export const UNIDENTIFIED_CUSTOMER_ERROR_CODE = 'UNIDENTIFIED_CUSTOMER';
export const UNIDENTIFIED_CUSTOMER_ERROR_MESSAGE = 'Unidentified Customer';

export function isUnidentifiedCustomerError(error: unknown): boolean {
  const message = (error as any)?.response?.errors?.[0]?.message || (error as any)?.message || '';

  return message === UNIDENTIFIED_CUSTOMER_ERROR_MESSAGE;
}

function logLogin({ email, error, eventType, level, store }: AuthenticateLogSchema) {
  // Suppress noisy known errors
  if (isUnidentifiedCustomerError(error)) return;
  try {
    fetch('/api/members/log-auth', {
      method: httpMethods.POST,
      body: JSON.stringify({
        email,
        env,
        ...(error ? { error } : {}),
        eventType,
        level,
        store
      })
    });
  } catch (err) {
    datadogRum.addError(err, {
      context: {
        email,
        eventType,
        level,
        store,
        source: 'logLogin'
      }
    });
  }
}

type LogLoginFnFields = Pick<AuthenticateLogSchema, 'email' | 'store'>;

export function logLoginAttempt({ email, store }: LogLoginFnFields) {
  logLogin({ email, eventType: authEventType.ATTEMPT, level: dataDogStatus.INFO, store });
}

export function logLoginSuccess({ email, store }: LogLoginFnFields) {
  logLogin({ email, eventType: authEventType.SUCCESS, level: dataDogStatus.INFO, store });
}

export function logLoginFail({
  email,
  error,
  store
}: LogLoginFnFields & Pick<AuthenticateLogSchema, 'error'>) {
  logLogin({
    email,
    eventType: authEventType.FAIL,
    error,
    level: dataDogStatus.ERROR,
    store
  });
}
